import { type FieldContentsData } from 'javascripts/shared-types';
import Field, { type Flavor } from '../../Field';

export class TeamStatusPill extends Field {
  static get availableForFlavors(): readonly Flavor[] {
    return ['develop', 'teamwork'];
  }

  static attributesForModel() {
    return ['teamId'];
  }

  static subqueriesForModel() {
    return { teamWorkflowStatus: ['name', 'color'] };
  }

  get title() {
    return 'Team status pill';
  }

  exampleContents(): FieldContentsData {
    return { pill: { text: 'In code review', color: '#674C75' } };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.teamId && record.teamWorkflowStatus) {
      return {
        pill: {
          text: record.teamWorkflowStatus.name,
          color: record.teamWorkflowStatus.colorObject.hex(),
        },
      };
    }

    return {};
  }
}
